export default __webpack_public_path__ + "static/hotel-389256_1280-e1aca6c098c3d9a63b204a383e469bfc.png";